import { RootState } from "../stores/mainStore";
import { CustomerFavoriteState } from "./CustomerFavouritesSlice";

export const selectCustomerFavorites = (state: RootState) => state.customerFavourites.favourites;
